import NavBar from "../NavBar/navbar";
import React, {useState} from 'react';
import {Checkbox, Table} from "antd";
import './invoicelistview.css';
import { SearchOutlined } from '@ant-design/icons';
import {Button} from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import {Form as FormR} from 'react-bootstrap';
import { Tooltip } from "antd";
import { canAccessPage, getTokenUser } from "../../helper/token";
import AxiosHelper from "../../helper/axios-helper";
import { useNavigate } from 'react-router-dom';

function Invoicelistview (){
    // const ACCOUNT_EMAIL = process.env.REACT_APP_ACCOUNTS_EMAIL;
    const[tableSize] = useState("col-12");
    const [invoiceSentFilters, setInvoiceSentFilter] = useState([]);
    const [invoicePaidFilters, setInvoicePaidFilter] = useState([]);
    const [customerFilters, setCustomerFilters] = useState([]);
    const [proposalFilters, setProposalFilters] = useState([]);  
    const [invoiceData, setInvoiceData] = useState([]);
    const [loggedInUser] = useState(getTokenUser());

    const [cancelModalShow, setCancelModalShow] = useState(false);
    const [sentSelectedFilters, setSentSelectedFilters] = useState([]);
    const [paidSelectedFilters, setPaidSelectedFilters] = useState([]);
    const [customerSelectedFilters, setCustomerSelectedFilters] = useState([]);
    const [proposalSelectedFilters, setProposalSelectedFilters] = useState([]);
    const navigate = useNavigate();
    //#endregion

    //#region Ant Table States & Functions

    // const onChange = (pagination, filters, sorter, extra) => {
    //     console.log('params', pagination, filters, sorter, extra);
    //   };

    //#endregion

    //#region Table column definitions
  
    const InvoiceLineColumns=[{
        title:"Line Description",
        dataIndex:"invoice_line_description",
        render: (text, record, index) => 
          <div>
            <p className="non-editable-cell">{record.invoice_line_description}</p>
          </div> 
    },
    {
        title:"Line Quantity",
        dataIndex:"invoice_line_quantity",
        render: (text, record, index) => 
          <div>
            <p className="non-editable-cell">{record.invoice_line_quantity}</p>
          </div> 
    },
    {
        title:"Line Unit Value",
        dataIndex:"invoice_line_unit_value",
        render: (text, record, index) => 
          <div>
            <p className="non-editable-cell">{record.invoice_line_unit_value.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')}</p>
          </div> 
    },
    {
        title:"Line Total Exc",
        dataIndex:"invoice_line_total_exc",
        render: (text, record, index) => 
          <div>
            <p className="non-editable-cell">{record.invoice_line_total_exc.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')}</p>
          </div> 
    },
    {
        title:"Line Total Inc",
        dataIndex:"invoice_line_total_inc",
        render: (text, record, index) => 
          <div>
            <p className="non-editable-cell">{record.invoice_line_total_inc.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')}</p>
          </div> 
    },
    {
        title:"Line Notes",
        dataIndex:"invoice_line_notes",
        render: (text, record, index) => 
          <div>
            <p className="non-editable-cell">{record.invoice_line_notes}</p>
          </div> 
    },
    {
        title:"Line Document",
        dataIndex:"invoice_line_file",
        render: (text, record, index) => <div>
                                            {  record.invoice_line_file === "" || record.invoice_line_file === null || record.invoice_line_file === "-"
                                                ? <p className="non-editable-cell">No File</p>
                                                : <a className="non-editable-cell" href={record.invoice_line_file} rel="noreferrer" target="_blank">View</a>
                                            }
                                        </div>
    }
    ];

    const InvoiceHeaderColumns =[
        {
            title:"Customer",
            dataIndex:"customer_name",
            filters: customerFilters,
            filterSearch: true,
            filteredValue: customerSelectedFilters,
            onFilter: (value, record) => record.customer_name.startsWith(value),
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? 'blue' : '#000000',fontSize: '16px' }} />,
        },
        {
            title:"Proposal",
            dataIndex:"proposal_name",
            filters: proposalFilters,
            filterSearch: true,
            filteredValue: proposalSelectedFilters,
            onFilter: (value, record) => record.proposal_name.startsWith(value),
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? 'blue' : '#000000',fontSize: '16px' }} />,
        },
        {
            title:"Description",
            dataIndex:"invoice_description",
                render: (text, record, index) => 
          <div>
            <p className="non-editable-cell">{record.invoice_description}</p>
          </div> 
        },
        {
            title:"Create Date",
            dataIndex:"invoice_create_date",
            key: 'invoice_create_date',
            sorter: (a, b) => new Date(a.invoice_create_date) - new Date(b.invoice_create_date),
            defaultSortOrder: 'descend',
            render: (text, record, index) => 
            <div>
                <p className="non-editable-cell">{record.invoice_create_date}</p>
            </div> 
        },
        {
            title:"Invoice Date",
            dataIndex:"invoice_date",
            key: "invoice_date",
            sorter: (a, b) => new Date(a.invoice_date) - new Date(b.invoice_date),
            defaultSortOrder: 'descend',
            render: (text, record, index) => 
            <div>
                <p className="non-editable-cell">{record.invoice_date}</p>
            </div> 
        },
        {
            title:"Total Exc",
            dataIndex:"invoice_total_exc",
            render: (text, record, index) => 
            <div>
                <p className="non-editable-cell">{record.invoice_total_exc.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')}</p>
            </div> 
        },
        {
            title:"Total Inc",
            dataIndex:"invoice_total_inc",
            render: (text, record, index) => 
            <div>
                <p className="non-editable-cell">{record.invoice_total_inc.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')}</p>
            </div> 
        },
        {
            title:"Sent",
            dataIndex:"invoice_sent",
            editable:true,
            filters: invoiceSentFilters,
            filterSearch: true,
            filteredValue: sentSelectedFilters,
            onFilter: (value, record) => (record.invoice_sent===true?"Yes":"No")===value,
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? 'blue' : '#000000',fontSize: '16px' }} />,
            render: (text, record) => 
                <div align="center">
                    <Checkbox 
                        checked={record.invoice_sent}
                        onChange={(e) => handleInvoiceSentChange(e, record)}
                    >
                    </Checkbox>
                </div>
        
        },
        {
            title:"Paid",
            dataIndex:"invoice_paid",
            editable:true,
            filters: invoicePaidFilters,
            filterSearch: true,
            filteredValue: paidSelectedFilters,
            onFilter: (value, record) => (record.invoice_paid===true?"Yes":"No")===value,
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? 'blue' : '#000000',fontSize: '16px' }} />,
            render: (text, record) => 
                <div align="center">
                    <Checkbox 
                        checked={record.invoice_paid}
                        onChange={(e) => handleInvoicePaidChange(e, record)}
                    >
                    </Checkbox>
                </div>
        },
        {
            title:"Date Paid",
            dataIndex:"invoice_date_paid",
            render: (text, record, index) => {
                let isValid = true;
          
                if(record.invoice_paid && record.invoice_date_paid===null){
                    isValid = false;
                }
                return(
                <div style={{display: "flex", position:"relative"}}>
                    {!isValid && 
                        <Tooltip title="Invoice is paid, please provide the payment date." color="#f88d8d">
                            <p className={"exclamation"}>!</p>
                        </Tooltip>
                    }
                    {record.invoice_paid ? (
                        <FormR.Control 
                            className={`editable-cell-input ${!isValid ? 'invalid-cell' : ''}`}
                            size="sm" 
                            type="date" 
                            disabled={!record.invoice_paid} 
                            defaultValue={record.invoice_date_paid} 
                            onBlur={(e) => handleInvDatePaidChange(e, record)}
                        ></FormR.Control>
                    ) : (
                        <p>-</p>
                    )}
                    {/* <p className="non-editable-cell">{record.invoice_date_paid}</p> */}
                </div> 
                )
            }
        },
        {
            title:"Reference",
            dataIndex:"invoice_ref",
            editable:true,
            render: (text, record, index) => 
                <div>
                    <FormR.Control className="editable-cell-input" size="sm" type="text" defaultValue={record.invoice_ref} onBlur={(e) => handleInvRefChange(e, record)}></FormR.Control>
                </div> 
        },
        {
            title:"Notes",
            dataIndex:"invoice_notes",
            render: (text, record, index) => 
                <div>
                    <p className="non-editable-cell">{record.invoice_notes}</p>
                </div> 
        },
        // {
        //     title:"Send Invoice",
        //     render: (record) => 
        //         <Button
        //             onClick={() => handleSendInvHeaderModalShow(record)}
        //             variant="outline-success"
        //         >
        //             Send
        //         </Button>
        // }
    ];

    //#endregion

    //#region Functions

    const notifySuccessful = (message) => {
        toast.success(message, {
          position: "bottom-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
    };
    
    const notifyFailed = (message) => {
        toast.error(message, {
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const handleInvoicePaidChange = (e, row) => {
        row.invoice_paid = e.target.checked;
        row.invoice_date_paid = null;
        handleSave(row);
        onTableDataChange(true);
    }

    const handleInvoiceSentChange = (e, row) => {
        row.invoice_sent = e.target.checked;
        handleSave(row);
        onTableDataChange(true);
    }

    const handleInvRefChange = (e, row) => {

        if (row.invoice_ref !== e.target.value) 
        {
          row.invoice_ref = e.target.value;
          handleSave(row);
          onTableDataChange(true);
        }

    }

    const handleInvDatePaidChange = (e, row) => {

        if (row.invoice_date_paid !== e.target.value) 
        {
          row.invoice_date_paid = e.target.value;
          handleSave(row);
          onTableDataChange(true);
        }

    }

    const handleSave = (row) => {

        const newData = [...invoiceData];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
        ...item,
        ...row,
        });
        setInvoiceData(newData);
    };

    function SaveTable()
    {
        try {
            let postedData = [];
            let tempHeader={}
            let tableValid = true;
            invoiceData.forEach(header=>{
                if (header.invoice_paid && header.invoice_date_paid === null) {
                    tableValid = false
                } 

                tempHeader = {
                    InvId: header.key,
                    InvDesc: header.invoice_description,
                    PropId: header.PropId,
                    InvCreateDate: header.invoice_create_date,
                    InvDate: header.invoice_date.substring(0,10),
                    InvTotalExc: parseFloat(header.invoice_total_exc),
                    InvTotalInc: parseFloat(header.invoice_total_inc),
                    InvSent: header.invoice_sent, //=== "Yes" ? true : false,
                    InvPaid: header.invoice_paid, //=== "Yes" ? true : false,
                    InvDatePaid: header.invoice_date_paid === null ? null : header.invoice_date_paid.substring(0,10),
                    InvRef: header.invoice_ref,
                    InvNotes: header.invoice_notes,
                    InvHeaderType: header.invoice_type,
                    InvLine: []
                }

                header.invoiceLines.forEach(line => {
                    let tempLine={
                        InvLineId: line.key,
                        InvId: parseInt(line.key),
                        InvLineDesc: line.invoice_line_description,
                        InvLineUnitQty: parseFloat(line.invoice_line_quantity),
                        InvLineUnitValue: parseFloat(line.invoice_line_unit_value),
                        InvLineTotalExc: parseFloat(line.invoice_line_total_exc),
                        InvLineTotalInc: parseFloat(line.invoice_line_total_inc),
                        InvLineNotes: line.invoice_line_notes,
                        InvLineFileLink: line.invoice_line_file,
                        InvLineType: line.invoice_line_type
                    }
                    tempHeader.InvLine.push(tempLine);
                });
                postedData.push(tempHeader);
            })

            if (tableValid) {
                AxiosHelper.makeAxiosRequest("Create", "InvHeaders", "CreateInvoiceHeader", {currentUserId : loggedInUser}, postedData)
                .then(()=>{
                    toast.dismiss();
                    notifySuccessful("Changes saved!");

                }).catch((Error)=>{
                    if(Error === 'ValidationError'){
                        console.log(Error);
                    }
                    console.log(Error);
                    notifyFailed("An Error Occurred, Please Try Again.")
                });
            } else {
                notifyFailed("Please ensure all invoices are correclty filled in.")
            }
            

        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };

    function populateUI()
    {
        try {
            AxiosHelper.makeAxiosRequest("Read", "invHeaders", "GetAllInvoicesWithCustomersAndProposals")
            .then((response) => {

                let tempInvoiceData = [];

                let tempSentFilters = [
                    {
                        text: 'Yes',
                        value: 'Yes'
                    },
                    {
                        text: 'No',
                        value: 'No'
                    },
                ];

                let tempPaidFilters = [
                    {
                        text: 'Yes',
                        value: 'Yes'
                    },
                    {
                        text: 'No',
                        value: 'No'
                    },
                ];
                let tempCustomerFilters = [];
                let tempProposalFilters = [];

                let tempInvoiceHeader={};
                let tempInvoiceLine = {};

                response.data.forEach(customer => {
                    if (customer.CustDeleted === false) {
                        customer.Proposal.forEach(proposal => {
                            if (proposal.PropDeleted === false) {
                                if (proposal.InvHeader.length > 0) {
                                    if(tempCustomerFilters.findIndex(item => item.value === customer.CustName)===-1){
                                        tempCustomerFilters.push({
                                            text: customer.CustName,
                                            value: customer.CustName
                                        })
                                    }
                                    if (tempProposalFilters.findIndex(item => item.value === proposal.PropName)===-1) {
                                        tempProposalFilters.push({
                                            text: proposal.PropName,
                                            value: proposal.PropName
                                        })
                                    }   
                                }
                            }
                        })                     
                    }                    
                })

                response.data.forEach(customer => {
                    if (customer.CustDeleted === false) {                        
                        customer.Proposal.forEach(proposal => {
                            if (proposal.PropDeleted === false) {
                                proposal.InvHeader.forEach(header => {
                                    if (header.InvDeleted === false) {
            
                                        tempInvoiceHeader = 
                                        {
                                            key:header.InvId,
                                            customer_name: customer.CustName,
                                            proposal_name: proposal.PropName,
                                            invoice_description:header.InvDesc,
                                            invoice_create_date:header.InvCreateDate.substring(0,10),
                                            invoice_date:header.InvDate.substring(0,10),
                                            invoice_total_exc:header.InvTotalExc.toFixed(2),
                                            invoice_total_inc:header.InvTotalInc.toFixed(2),
                                            invoice_sent:header.InvSent,
                                            invoice_paid:header.InvPaid,
                                            invoice_date_paid: header.InvDatePaid === null ? null : header.InvDatePaid.substring(0,10),
                                            invoice_ref:header.InvRef,
                                            invoice_notes:header.InvNotes,
                                            invoice_type:'server',
                                            invoiceLines:[]
                                        }
                                        header.InvLine.forEach(line=>{
                                            if (line.InvLineDeleted === false) {
                                                tempInvoiceLine = {
                                                    key:line.InvLineId,
                                                    invoice_line_headId:header.InvId,
                                                    invoice_line_description:line.InvLineDesc,
                                                    invoice_line_quantity:line.InvLineUnitQty,
                                                    invoice_line_unit_value:line.InvLineUnitValue.toFixed(2),
                                                    invoice_line_total_exc:line.InvLineTotalExc.toFixed(2),
                                                    invoice_line_total_inc:line.InvLineTotalInc.toFixed(2),
                                                    invoice_line_notes:line.InvLineNotes,
                                                    invoice_line_file:line.InvLineFileLink,
                                                    invoice_line_type:'server',
                                                }
                                                tempInvoiceHeader.invoiceLines.push(tempInvoiceLine);
                                            }
                                            
                                        });
                                        tempInvoiceData.push(tempInvoiceHeader)
                                    }
                                })    
                            }   
                        })
                    }
                })                   
                setInvoicePaidFilter(tempPaidFilters);
                setInvoiceSentFilter(tempSentFilters);
                setCustomerFilters(tempCustomerFilters);
                setProposalFilters(tempProposalFilters);
                //console.log("'Invoice data")
                //console.log(tempInvoiceData)
                setInvoiceData(tempInvoiceData);
            })
        } 
        catch (error) 
        {
            console.log(error);
        }
    }

    const onChange = (page,filter,sorter) => {
        setSentSelectedFilters(filter.invoice_sent);
        setPaidSelectedFilters(filter.invoice_paid);
        setCustomerSelectedFilters(filter.customer_name);
        setProposalSelectedFilters(filter.proposal_name);
    };   

    const notifyChanges = (message) => {
        toast.warning(message, {
            toastId: "ToastDataTableWarning",
            position: "top-right",
            autoClose: false,
            closeOnClick: true,
            draggable: false,
            progress: undefined,
            closeButton: true
          });
        };

    function onTableDataChange(isDirty)
    {
        if (isDirty) 
        {
        notifyChanges("Data table contains unsaved changes.");
        }
        else
        {
        toast.dismiss();
        }
    }

    const handleCancelModalClose = () => setCancelModalShow(false);
    const handleCancelModalShow = () => setCancelModalShow(true);

    function onCancelChanges()
    {
        populateUI();
        onTableDataChange(false);
        notifySuccessful("Changes Successfully Cleared!");
        handleCancelModalClose();
    }

    //#endregion

    //#endregion

    //#region region UI Population

    React.useEffect(()=>{
        if(!canAccessPage('Invoice')){
            navigate('/login');
        }
        populateUI();
    },[]);

    //#endregion 

    return(
        <div>

            {/* Confirm Cancel Modal */}

            <Modal centered show={cancelModalShow} onHide={handleCancelModalClose}>

                <Modal.Header closeButton>
                    <Modal.Title>Clear Changes</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{display: "flex", flexDirection: "column"}}>
                        <div>
                            <p className="p-main">
                                Are you sure you want to clear any changes made?
                                <br />
                                This does not include items that have been deleted.
                            </p>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleCancelModalClose}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={onCancelChanges}>
                        Clear Changes
                    </Button>
                </Modal.Footer>

            </Modal>

            {/* Send Invoice Modal */}

            {/* <Modal centered show={sendInvHeaderModalShow} onHide={handleSendInvHeaderModalClose}>

                <Modal.Header closeButton>
                    <Modal.Title>Send Invoice</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{display: "flex", flexDirection: "column"}}>
                        <div>
                            <p className="p-main">
                                Are you sure you want to send the following invoice?
                            </p>
                        </div>
                        <div>
                            <p className="p-main">{selectedSendInvoice.invoice_description}</p>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleSendInvHeaderModalClose}>
                        Cancel
                    </Button>
                    <Button variant="success" onClick={() => sendEmail(selectedSendInvoice)}>
                        Send Invoice
                    </Button>
                </Modal.Footer>

            </Modal> */}

            <ToastContainer />
            <NavBar/>
            <div id="invoicelistview-body">
                <h1>Invoices</h1>
                <div className={tableSize}>
                    <div id="home-table-container">
                        <Table
                            columns={InvoiceHeaderColumns} 
                            pagination={{
                                position: ["bottomCenter"],
                                showSizeChanger: true,
                                defaultPageSize: 20,
                                hideOnSinglePage: false,
                                pageSizeOptions: [5 , 10, 20, 50, 100]
                              }}
                            dataSource={invoiceData}
                            onChange={onChange}
                            footer={() => (
                                <div style={{ display: "flex", justifyContent: "right", gap: "20px" }}>
                                    <Button
                                    variant="danger"
                                    onClick={handleCancelModalShow}
                                    >
                                        Clear Changes
                                    </Button>
                                    <Button
                                        onClick={SaveTable}
                                        variant="success"
                                    >
                                        Save Changes
                                    </Button>
                                </div>
                                )}
                            expandable={{rowExpandable:(record2)=>true,
                                expandedRowRender:(record2)=>{
                                    return (
                                    <Table 
                                    columns={InvoiceLineColumns} 
                                    dataSource={record2.invoiceLines}
                                    pagination={{
                                        position: ["bottomCenter"],
                                        showSizeChanger: false,
                                        defaultPageSize: 100,
                                        hideOnSinglePage: true,
                                        pageSizeOptions: [5 , 10, 20, 50, 100]
                                      }}
                                    >
                                    </Table>);
                                }}}>
                        </Table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Invoicelistview